<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: { Layout },
  data() {
    return {
      step: 1, // 1: Seleção, 2: Dados
      types: [],
      /** Carregamento da lista de tipos (passo 1) */
      typesLoading: true,
      serviceNameFilter: "",
      serviceTableFields: [
        { key: "name", label: "Nome", sortable: true, tdClass: "align-middle font-weight-semibold" },
        { key: "description", label: "Descrição", sortable: false, tdClass: "align-middle text-muted" },
        {
          key: "balance",
          label: "Saldo",
          sortable: true,
          class: "text-right",
          tdClass: "align-middle text-right font-weight-semibold",
        },
        { key: "actions", label: "", class: "text-right", tdClass: "align-middle text-right" },
      ],

      form: {
        id: null,
        name: "",
        person_type: "cpf",
        person_number: "",
        loading: false,
        error: "",
      },

      showModal: false,
    };
  },
  computed: {
    selectedType() {
      return this.types.find((x) => String(x.id) === String(this.form.id));
    },
    currentServiceLabel() {
      return this.selectedType ? this.selectedType.name : "";
    },
    /** CPF e CNPJ permitidos no tipo selecionado */
    hasBothPersonTypes() {
      const pt = this.selectedType && this.selectedType.person_types;
      if (!Array.isArray(pt)) return false;
      return pt.includes("cpf") && pt.includes("cnpj");
    },
    /** Depende do documento: CPF → Nome, CNPJ → Razão Social */
    personNameLabel() {
      return this.form.person_type === "cnpj" ? "Razão Social" : "Nome";
    },
    filteredTypes() {
      const q = (this.serviceNameFilter || "").trim().toLowerCase();
      if (!q) {
        return this.types;
      }
      return this.types.filter((t) => String(t.name || "").toLowerCase().includes(q));
    },
  },
  watch: {
    "form.id"(newVal) {
      if (newVal) {
        this.adjustPersonType();
      }
    },
  },
  methods: {
    loadData() {
      this.form.error = "";
      this.typesLoading = true;
      api
        .get("consultas/types")
        .then((typesRes) => {
          if (typesRes.data.status === "success" && typesRes.data.list) {
            this.types = typesRes.data.list.map((t) => {
              const pt = Array.isArray(t.person_types) && t.person_types.length ? t.person_types : ["cpf", "cnpj"];
              return { ...t, person_types: pt };
            });
          } else {
            this.types = [];
          }
        })
        .catch(() => {
          this.types = [];
        })
        .finally(() => {
          this.typesLoading = false;
        });
    },
    typeBalance(type) {
      if (!type) return 0;
      const b = type.balance;
      return b != null && b !== "" ? Number(b) : 0;
    },
    selectType(type) {
      this.form.error = "";
      if (this.typeBalance(type) < 1) {
        this.$toast.error("Saldo insuficiente para este tipo de consulta.");
        this.form.id = null;
        return;
      }
      this.form.id = type.id;
      this.adjustPersonType();
      this.step = 2;
    },
    adjustPersonType() {
      const types = this.selectedType && this.selectedType.person_types;
      if (Array.isArray(types) && types.length) {
        if (types.length === 1) {
          this.form.person_type = types[0];
        } else if (!types.includes(this.form.person_type)) {
          this.form.person_type = types[0];
        }
      }
    },
    goBack() {
      this.step = 1;
      this.form.error = "";
    },
    openConfirmModal() {
      this.form.error = "";

      if (!this.form.name) {
        this.form.error =
          this.form.person_type === "cnpj" ? "Informe a razão social." : "Informe o nome.";
        return;
      }
      if (!this.form.person_number) {
        this.form.error = `Informe o ${this.form.person_type === 'cpf' ? 'CPF' : 'CNPJ'}.`;
        return;
      }

      this.showModal = true;
    },
    confirmConsulta() {
      this.showModal = false;
      this.form.loading = true;

      api
        .post("consultas", {
          id: this.form.id,
          name: this.form.name,
          person_type: this.form.person_type,
          person_number: this.form.person_number.replace(/\D/g, ""),
        })
        .then((response) => {
          if (response.data.status === "success" && response.data.consulta) {
            this.$toast.success("Consulta solicitada com sucesso!");
            this.$router.push("/consultas/" + response.data.consulta.id);
          } else {
            this.form.error = response.data.message || "Não foi possível realizar a consulta.";
          }
        })
        .catch(() => {
          this.form.error = "Erro ao processar. Tente novamente.";
        })
        .finally(() => {
          this.form.loading = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">
        <router-link tag="a" to="/consultas">Consultas</router-link>
      </li>
      <li class="breadcrumb-item d-none d-sm-block">Nova Consulta</li>
    </ol>

    <div class="row align-items-center mb-4">
      <div class="col">
        <h3 class="mb-0">Nova Consulta</h3>
      </div>
    </div>

    <!-- Indicador de Passo: um rótulo acima de cada metade da barra -->
    <div class="mb-4 consulta-steps-indicator">
      <div class="row mb-2">
        <div class="col-6 text-center px-1">
          <span
            class="consulta-steps-indicator__label d-inline-block"
            :class="step === 1 ? 'text-primary font-weight-bold' : 'text-muted'"
          >1. Seleção do Serviço</span>
        </div>
        <div class="col-6 text-center px-1">
          <span
            class="consulta-steps-indicator__label d-inline-block"
            :class="step === 2 ? 'text-primary font-weight-bold' : 'text-muted'"
          >2. Dados da Consulta</span>
        </div>
      </div>
      <b-progress
        :max="2"
        :value="step"
        height="8px"
        variant="primary"
        class="consulta-steps-progress"
      />
    </div>

    <!-- Passo 1: seleção via tabela -->
    <div v-if="step === 1" class="row justify-content-center">
      <div class="col-md-12">
        <div class="card consulta-step1-card">
          <div class="card-body p-4">
            <h5 class="mb-2">Selecione o Serviço</h5>
            <p class="text-muted mb-4">Escolha o tipo de consulta na lista abaixo</p>

            <div v-if="typesLoading" class="consulta-types-skeleton" aria-hidden="true">
              <div class="form-group mb-3">
                <div class="cns-sk-line cns-sk-w-35 mb-2" style="height: 12px"></div>
                <div class="cns-sk-line cns-sk-w-100" style="height: 38px; border-radius: 4px"></div>
              </div>
              <div class="table-responsive">
                <table class="table table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th class="border-0">
                        <div class="cns-sk-line cns-sk-w-40" style="height: 12px"></div>
                      </th>
                      <th class="border-0 d-none d-md-table-cell">
                        <div class="cns-sk-line cns-sk-w-55" style="height: 12px"></div>
                      </th>
                      <th class="border-0 text-right" style="width: 88px">
                        <div class="cns-sk-line cns-sk-w-50 ml-auto" style="height: 12px"></div>
                      </th>
                      <th class="border-0 text-right" style="width: 110px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="n in 5" :key="'sk-row-' + n">
                      <td class="align-middle">
                        <div class="cns-sk-line cns-sk-w-70 mb-1" style="height: 14px"></div>
                        <div class="cns-sk-line cns-sk-w-45 d-md-none" style="height: 10px"></div>
                      </td>
                      <td class="align-middle d-none d-md-table-cell">
                        <div class="cns-sk-line cns-sk-w-90" style="height: 12px"></div>
                        <div class="cns-sk-line cns-sk-w-60 mt-1" style="height: 10px"></div>
                      </td>
                      <td class="align-middle text-right">
                        <div class="cns-sk-line cns-sk-w-30 ml-auto" style="height: 14px"></div>
                      </td>
                      <td class="align-middle text-right">
                        <div class="cns-sk-pill ml-auto"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <template v-else-if="types.length">
              <div class="form-group mb-3">
                <label for="consulta-service-filter">Filtrar por nome</label>
                <b-form-input
                  id="consulta-service-filter"
                  v-model="serviceNameFilter"
                  type="search"
                  autocomplete="off"
                  placeholder=""
                  debounce="200"
                />
              </div>

              <b-table
                :items="filteredTypes"
                :fields="serviceTableFields"
                class="table-nowrap table-style table-hover mb-0"
                head-variant="light"
                responsive
                show-empty
              >
                <template #cell(balance)="{ item }">
                  {{ typeBalance(item) }}
                </template>
                <template #cell(actions)="{ item }">
                  <button
                    type="button"
                    class="btn btn-default btn-sm btn-rounded"
                    @click="selectType(item)"
                  >
                    Selecionar
                    <i class="mdi mdi-arrow-right ml-1"></i>
                  </button>
                </template>
              </b-table>
            </template>
            <p v-else class="text-muted mb-0">Nenhum tipo de consulta disponível no momento.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Passo 2: Dados -->
    <div class="card" v-if="step === 2">
      <div class="card-body p-4">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div class="d-flex flex-column flex-md-row align-items-stretch align-items-md-center mb-3">
              <div class="d-flex align-items-center flex-grow-1 min-w-0 mb-3 mb-md-0">
                <div class="avatar-sm bg-soft-primary text-primary rounded-circle mr-3 d-flex align-items-center justify-content-center flex-shrink-0" style="width: 45px; height: 45px;">
                  <i class="bx bx-search-alt fs-24"></i>
                </div>
                <div class="flex-fill min-w-0">
                  <h5 class="mb-0 text-dark text-truncate">{{ currentServiceLabel }}</h5>
                  <p class="text-muted mb-0 small">Preencha os dados abaixo para continuar</p>
                </div>
              </div>
              <button type="button" class="btn btn-outline-secondary flex-shrink-0 consulta-step2-change-btn" @click="goBack">
                Alterar
              </button>
            </div>

            <b-alert v-if="form.error" show variant="danger" class="mb-4 py-3">
              <i class="bx bx-error-circle mr-2"></i> {{ form.error }}
            </b-alert>

            <div v-if="hasBothPersonTypes" class="form-group mb-3">
              <label for="consulta-person-type">Tipo de Documento</label>
              <select id="consulta-person-type" v-model="form.person_type" class="form-control">
                <option
                  v-if="!selectedType || (selectedType.person_types && selectedType.person_types.includes('cpf'))"
                  value="cpf"
                >CPF</option>
                <option
                  v-if="!selectedType || (selectedType.person_types && selectedType.person_types.includes('cnpj'))"
                  value="cnpj"
                >CNPJ</option>
              </select>
            </div>

            <div class="form-group mb-3">
              <label for="consulta-name">{{ personNameLabel }}</label>
              <input id="consulta-name" v-model="form.name" type="text" class="form-control" placeholder="" />
            </div>

            <div class="form-group mb-3">
              <label for="consulta-person-number">{{ form.person_type === 'cpf' ? 'CPF' : 'CNPJ' }}</label>
              <input
                id="consulta-person-number"
                v-model="form.person_number"
                v-mask="form.person_type === 'cpf' ? '###.###.###-##' : '##.###.###/####-##'"
                type="text"
                class="form-control"
                :placeholder="form.person_type === 'cpf' ? '000.000.000-00' : '00.000.000/0000-00'"
              />
            </div>

            <button class="btn btn-default btn-block btn-lg mt-3" :disabled="form.loading" @click="openConfirmModal">
              <b-spinner v-if="form.loading" small class="mr-2" variant="white"></b-spinner>
              <i v-else class="bx bx-check-double mr-2"></i>
              Confirmar Solicitação
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmação -->
    <b-modal
      v-model="showModal"
      modal-class="modal-bottom"
      centered
      hide-header
      hide-footer
      header-class="border-0"
    >
      <div class="text-center mb-4">
        <div class="avatar-lg bg-soft-warning text-warning rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center" style="width: 70px; height: 70px;">
          <i class="bx bx-info-circle display-4"></i>
        </div>
        <h5>Deseja prosseguir?</h5>
      </div>

      <div class="p-3 bg-light rounded mb-4">
        <div class="d-flex justify-content-between mb-2">
          <span class="text-muted">Serviço:</span>
          <span class="font-weight-bold">{{ currentServiceLabel }}</span>
        </div>
        <div class="d-flex justify-content-between mb-2">
          <span class="text-muted">Documento:</span>
          <span class="font-weight-bold">{{ form.person_number }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span class="text-muted">Custo:</span>
          <span class="text-danger font-weight-bold">1 Crédito</span>
        </div>
      </div>

      <div class="row">
        <div class="col-6 pr-2">
          <button class="btn btn-outline-secondary btn-lg btn-block" @click="showModal = false">Cancelar</button>
        </div>
        <div class="col-6 pl-2">
          <button class="btn btn-default btn-block btn-lg" @click="confirmConsulta">Confirmar</button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped lang="scss">
.avatar-sm, .avatar-lg {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta-steps-indicator__label {
  font-size: 0.8125rem;
  line-height: 1.3;
  max-width: 100%;
}

@media (min-width: 576px) {
  .consulta-steps-indicator__label {
    font-size: 0.9rem;
  }
}

.consulta-steps-progress {
  border-radius: 6px;
  overflow: hidden;
}

.consulta-step1-card {
  overflow: visible;
}

/* Botão Alterar: largura total no mobile, à direita no desktop (Bootstrap 4 não tem w-md-auto) */
.consulta-step2-change-btn {
  width: 100%;
}

@media (min-width: 768px) {
  .consulta-step2-change-btn {
    width: auto;
  }
}

/* Skeleton da lista de tipos (passo 1) */
.consulta-types-skeleton .cns-sk-line,
.consulta-types-skeleton .cns-sk-pill {
  background: linear-gradient(
    90deg,
    #e8e8e8 25%,
    #f5f5f5 50%,
    #e8e8e8 75%
  );
  background-size: 200% 100%;
  animation: consulta-nova-skeleton-shimmer 1.4s infinite ease-in-out;
  border-radius: 4px;
}

.consulta-types-skeleton .cns-sk-pill {
  width: 88px;
  height: 31px;
  border-radius: 4px;
}

.consulta-types-skeleton .cns-sk-w-30 {
  width: 30%;
}

.consulta-types-skeleton .cns-sk-w-35 {
  width: 35%;
}

.consulta-types-skeleton .cns-sk-w-40 {
  width: 40%;
}

.consulta-types-skeleton .cns-sk-w-45 {
  width: 45%;
}

.consulta-types-skeleton .cns-sk-w-50 {
  width: 50%;
}

.consulta-types-skeleton .cns-sk-w-55 {
  width: 55%;
}

.consulta-types-skeleton .cns-sk-w-60 {
  width: 60%;
}

.consulta-types-skeleton .cns-sk-w-70 {
  width: 70%;
}

.consulta-types-skeleton .cns-sk-w-90 {
  width: 90%;
}

.consulta-types-skeleton .cns-sk-w-100 {
  width: 100%;
}

@keyframes consulta-nova-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

body[data-sidebar="dark"] .consulta-types-skeleton .cns-sk-line,
body[data-sidebar="dark"] .consulta-types-skeleton .cns-sk-pill {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.08) 25%,
    rgba(255, 255, 255, 0.14) 50%,
    rgba(255, 255, 255, 0.08) 75%
  );
  background-size: 200% 100%;
}
</style>
